import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from "@services/auth/auth.service";
import {distinctUntilChanged, map} from "rxjs/operators";
import {appRoutingEnum} from "@enums/appRoutingEnum";
import {StatusEnum} from "@enums/statusEnum";

@Injectable({
  providedIn: 'root'
})
export class SubscriberGuard implements CanActivate {
  private isSubscribed: boolean = false;
  private isAccountLess2DaysOld: boolean = true;
  private isStatus: boolean = true;

  constructor(private auth: AuthService, private router: Router) {
    auth.isAccountLessThan2DaysOld$
      .pipe(distinctUntilChanged()).subscribe(value =>
      this.isAccountLess2DaysOld = value)
    auth.isPaying$
      .pipe(distinctUntilChanged()).subscribe(value =>
      this.isSubscribed = value
    )
    auth.status$
      .pipe(map(status => !!status), distinctUntilChanged()).subscribe(value =>
      this.isStatus = value
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // console.log('guard-subscribe');
    // console.log(this.isSubscribed);
    if (this.isSubscribed || this.isAccountLess2DaysOld) {
      return true;
    }

    //console.log(this.auth.getIsPayingFromStorage().pipe(map(isPaying => isPaying ? true : this.router.parseUrl(appRoutingEnum.SUBSCRIPTION))));
    return this.auth.getIsPayingFromStorage().pipe(map(isPaying => isPaying ? true : this.router.parseUrl(appRoutingEnum.SUBSCRIPTION)));
  }

}
